import React from 'react';
import { useLocation } from 'react-router-dom';
import { Box, useMediaQuery } from '@mui/material';
import SkeletonLoader from './SkeletonLoader';

const RouteSkeleton = ({ embedded = false }) => {
  const location = useLocation();
  const pathname = location.pathname;
  const isNonMobileScreens = useMediaQuery("(min-width:1000px)");

  // Determine which skeleton to show based on route (content only, no shell)
  const getSkeletonForRoute = () => {
    if (pathname === '/home') {
      return <SkeletonLoader.StatsDashboard />;
    }

    if (pathname === '/decks') {
      return <SkeletonLoader.DecksPage />;
    }

    if (pathname.startsWith('/profile/')) {
      return (
        <div>
          <SkeletonLoader.UserWidget />
          <div style={{ marginTop: '16px' }}>
            <SkeletonLoader.Card height={200} showAvatar={true} />
            <SkeletonLoader.Card height={150} showAvatar={true} />
            <SkeletonLoader.Card height={180} showAvatar={true} />
          </div>
        </div>
      );
    }

    if (pathname === '/explore') {
      return (
        <div>
          {Array.from({ length: 6 }).map((_, index) => (
            <SkeletonLoader.Card key={index} height={160} showAvatar={true} />
          ))}
        </div>
      );
    }

    if (pathname.startsWith('/study/')) {
      return (
        <Box sx={{ textAlign: 'center', p: '2rem' }}>
          <SkeletonLoader.Card height={300} />
        </Box>
      );
    }

    if (pathname === '/stats') {
      return <SkeletonLoader.StatsDashboard />;
    }

    if (pathname === '/admin') {
      return <SkeletonLoader.DecksPage />;
    }

    if (pathname === '/learn') {
      return (
        <div>
          {Array.from({ length: 4 }).map((_, index) => (
            <SkeletonLoader.Card key={index} height={120} />
          ))}
        </div>
      );
    }

    // Default skeleton for other routes
    return <SkeletonLoader.StatsDashboard />;
  };

  const content = getSkeletonForRoute();

  if (embedded) {
    // Rendered inside AppLayout: keep the real navbar/sidebar mounted and
    // only skeleton the page content area.
    return (
      <Box
        width="100%"
        padding={isNonMobileScreens ? "2rem 5%" : "1rem 4% 5rem 4%"}
        sx={{ overflowY: 'auto', height: '100%' }}
      >
        {content}
      </Box>
    );
  }

  return <SkeletonLoader.Page>{content}</SkeletonLoader.Page>;
};

export default RouteSkeleton;
